<template>
      <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">

          <v-card-title>
            <h3 class="headline mb-0"><span style="color: #9C1A1A">Edita los datos de Factura</span></h3>
          </v-card-title>

          <v-card-text>

                <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center>

                        <v-flex xs12 md4>
                            <v-text-field
                                required
                                prepend-icon="featured_video"
                                v-model="form.rif"
                                label="Rif"
                                :rules="[v => !!v || 'Rif es requerido']"
                                mask="A-########-#"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 md8>
                            <v-text-field
                                :rules="[v => !!v || 'Razon social es requerido']"
                                required
                                prepend-icon="person"
                                v-model="form.razon_social"
                                label="Cliente"
                            ></v-text-field>
                        </v-flex>

                    </v-layout>
                </v-flex>

                <v-select
                    v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                    prepend-icon="account_balance"
                    :items="banks"
                    v-model="form.bank_id"
                    item-text="name"
                    item-value="id"
                    label="Banco"
                    :rules="[v => !!v || 'Banco es requerido']"
                    required
                ></v-select>

                <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center>

                        <v-flex xs12 md6>
                            <v-select
                                prepend-icon="payment"
                                :items="wayToPay"
                                v-model="form.way_to_pay"
                                @change="changeWayToPay"
                                label="Método de pago"
                                :rules="[v => !!v || 'Método de pago es requerido']"
                                required
                            ></v-select>
                        </v-flex>

                        <v-flex xs12 md6>
                            <v-text-field
                                required
                                :rules="[v => !!v || 'Numero Transacción es requerido']"
                                prepend-icon="drag_handle"
                                v-model="form.number"
                                label="Numero Transaccion"
                            ></v-text-field>
                        </v-flex>

                    </v-layout>
                </v-flex>

                <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center>
                        
                        <v-flex xs12 md4>
                            <v-menu
                                ref="menu"
                                lazy
                                :close-on-content-click="false"
                                v-model="menu"
                                transition="scale-transition"
                                offset-y
                                full-width
                                :nudge-right="40"
                                min-width="290px"
                                :return-value.sync="form.payment_date"
                            >
                                <v-text-field
                                    slot="activator"
                                    label="Fecha"
                                    v-model="computedDateFormattedFecha"
                                    hint="DD/MM/YYYY formato"
                                    prepend-icon="event"
                                    :rules="[v => !!v || 'Fecha es requerido']"
                                    required
                                    readonly
                                ></v-text-field>
                                <v-date-picker v-model="form.payment_date" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="$refs.menu.save(form.payment_date)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-flex>

                        <v-flex xs12 md4>
                            <v-text-field
                                readonly
                                prepend-icon="account_balance_wallet"
                                v-model="form.amount"
                                label="Monto"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field
                                readonly
                                prepend-icon="settings_backup_restore"
                                v-model="form.status"
                                label="Estatus"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-text-field
                    required
                    prepend-icon="insert_comment"
                    v-model="form.observations"
                    label="Observaciones"
                ></v-text-field>

          </v-card-text>

          <v-card-actions>
            <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn :loading="loading" class="primary" @click="updateInvoice">Actualizar</v-btn>
          </v-card-actions>

        </v-form>
      </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import Form from 'vform'

export default {
    
    name: 'form-invoice-edit-view',

    props: {
        loading: {
            type: Boolean,
            required: true
        },
        datos: {
            type: Object,
            required: true
        }
    },

    watch: {
        datos(v) {
            this.$refs.form.resetValidation()
            Object.assign(this.form, v)
            this.form.bank_name = v.bank.name
            this.form.unionize_cpc = v.unionize.cpc
        }
    },

    computed: {
        ...mapGetters({
            banks: 'getAllBanks',
        }),
        computedDateFormattedFecha () {
            return this.formatDate(this.form.payment_date)
        }
    },

    mounted() {
        this.$store.dispatch('fetchBanks')
    },

    data: () => ({
        menu: false,
        valid: false,
        dialogAnulacion: false,
        status: ['PAGADO','PENDIENTE','ANULADO'],
        wayToPay: [
            'PUNTO ELECTRONICO',
            'EFECTIVO - MONEDA LOCAL',
            'EFECTIVO - DIVISAS',
            'TRANSFERENCIA'
        ],
        formAnulacion: new Form({
            motivo_anulacion: '',
        }),
        form: new Form({
            id: '',
            rif: '',
            bank_id: '',
            bank_name: '',
            unionize_cpc: '',
            electronic_point_id: '',
            direccion_fiscal: '',
            razon_social: '',
            way_to_pay: '',
            status: '',
            number: '',
            payment_date: '',
            observations: '',
            amount: ''
        })
    }),

    mounted() {
        this.$store.dispatch('clearMessage')
    },

    methods: {

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        cerrarDialog (data) {
            this.$emit('closeDialogInvoiceEdit', data)
            this.$nextTick(() => {
                this.$refs.form.resetValidation()
                this.$emit('responseLoading', false)
            })
        },

        async changeWayToPay() {
            if(this.form.way_to_pay != 'PUNTO ELECTRONICO'){
                this.form.electronic_point_id = ''
            }
            if(this.form.way_to_pay == 'EFECTIVO - MONEDA LOCAL'){
                this.form.number = null
            }
            if(this.form.way_to_pay == 'EFECTIVO - DIVISAS'){
                this.form.number = null
            }
        },

        async updateInvoice () {
            this.$emit('responseLoading', true)
            await axios.post('/api/administration/cobranza/conciliacion-update-invoice',this.form).then((resp) => {
                console.log(resp,'resp')
                this.$store.dispatch('responseMessage', {
                    type: 'success',
                    text: `Factura actualizada con Exito!`
                })
                this.cerrarDialog(resp)
            }).catch((error) => {
                if(error.response){
                    if(error.response.status == 404){
                        this.$store.dispatch('responseMessage', {
                            type: 'error',
                            text: 'No se encontro la factura, intente nuevamente.'
                        })   
                    }else if(error.response.status == 403) {
                        this.$store.dispatch('responseMessage', {
                            type: 'error',
                            text: 'No es posible actualizar esta factura.'
                        })  
                    }
                } else {
                    console.log('Error', error.message);
                }
            }).finally(() => this.$emit('responseLoading', false))
        }

    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cobranza/formInvoiceEdit.vue